export const GET_ALL_STATIC_PAGES = 'GET_ALL_STATIC_PAGES'
export const GET_SINGLE_STATIC_PAGE = 'GET_SINGLE_STATIC_PAGE'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_ALL_BID_INCREMENTS = 'GET_ALL_BID_INCREMENTS'
export const GET_ALL_TABLE_VALUES = 'GET_ALL_TABLE_VALUES'
export const GET_SINGLE_BID_INCREMENT = 'GET_SINGLE_BID_INCREMENT'
export const SEARCH_TABLE = 'SEARCH_TABLE'
export const GET_FETCH_DATA = 'GET_FETCH_DATA'
export const GET_ALL_GROUP_TABLE_VALUES = 'GET_ALL_GROUP_TABLE_VALUES'
export const GET_ALL_GLOBAL_CUSTOM_DATA = 'GET_ALL_GLOBAL_CUSTOM_DATA'
export const POST_WITHDRAWAL_REQUEST = 'POST_WITHDRAWAL_REQUEST'
export const GET_WITHDRAWAL_REQUEST = 'GET_WITHDRAWAL_REQUEST'
export const FETCH_AUDIT_TRAIT = 'FETCH_AUDIT_TRAIT'
export const GET_MATCH_WON_PRICE = 'GET_MATCH_WON_PRICE'
export const GET_USER_ADDRESS_DETAIS = 'GET_USER_ADDRESS_DETAIS'
export const GET_SERIAL_CHECK = 'GET_SERIAL_CHECK'
export const CLEAR_SERIAL_CHECK = 'CLEAR_SERIAL_CHECK'
export const GET_CIGARS_UPLOADS = 'GET_CIGARS_UPLOADS'
